export const CD_ORIGINE_RICHIESTA = {
  esperienzaEsternaAlPortaleWeMi: 0,
  assunzioneDiretta: 1,
  spaziWeMi: 2,
  librettoDiFamiglia: 3,
  acquistoServizioEnte: 4,
};